/* eslint-disable import/prefer-default-export */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import {
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  ComposedModal,
  ModalHeader,
  ModalBody,
  TableToolbar,
  FormGroup,
} from 'carbon-components-react';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import { Delete16, Add16, Download16 } from '@carbon/icons-react';
import FileUpload from '../common/FileUpload';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { ComboBox } from '../../helpers/ComboBox';
import { api } from '../../helpers/api/api';
import { getError, entitiesLabels, apioperation } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import FileDownLoadButton from '../common/FileDownloadButton';
import { Online, Offline } from '../common/OnLineOffLine';
const AttachmentTypes = [
  'Accident Investigation Report (Signed)',
  'Pictures',
  'Sketches',
  'Medical Reports',
  'HSE Training',
  'Tool Box Talks',
  'Permit To Work',
  'Job Safety Analysis',
  'Witness Statement',
  'Other Documentation (specify)',
];
const AttachmentTypesNotification = ['Pictures', 'Files'];

export class IncidentAttachment extends Component {
  clearAttachment = () => ({
    id: null, // guid
    fileIdentifier: null,
    name: null,
    contentType: null,
    size: null,
    type: null,
  });

  initialState = (props) => ({
    idIncident: props.idIncident, // guid
    attachment: this.clearAttachment(),
    attachmentTypes: this.props.flagNotificationTab ? AttachmentTypesNotification : AttachmentTypes,
    key: `modalAtt_${new Date().getTime()}`,
    isOpenModal: false,
  });

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      ...this.initialState(props),
    };
  }

  toggleModal = (open) => {
    this.setState({
      isOpenModal: open,
      attachmentTypes: this.props.flagNotificationTab
        ? AttachmentTypesNotification
        : AttachmentTypes,
    });
  };

  addAttachment = () => {
    this.setState({ key: `modalAtt_${new Date().getTime()}`, isOpenModal: true });
  };

  downloadAttachment = async (item) => {
    try {
      // this.setState({ downloading: id });
      const file = (
        await api.getBlob(
          `/incident/${this.state.idIncident}/attachment/${item.attachment.fileIdentifier}`
        )
      ).data;
      return this.downloadFile(file, item.attachment.name);
    } catch (error) {
      return showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.FileUpload, apioperation.GET)
      );
    } finally {
      // this.setState({ downloading: null });
    }
  };

  downloadFile(blob, fileName) {
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  // downloadAttachment(item) {
  //     incident.getAttachment(this.state.idIncident, { params: { filePath: item.attachment.filePath } })
  //         .then(response => {
  //             window.open(response.data);

  //         }).catch(error => {
  //             showNotification.error(getError(error, entitiesLabels.ATTACHMENT, apioperation.POST));

  //         }).finally(() => {

  //         });
  // }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  onUpload = (fileIdentifier, fileName, fileType, size) => {
    var last = fileName.split('.').pop();
    if (
      this.state.attachment.type === 'Pictures' &&
      //RITM1019407
      last.toLowerCase() !== 'jpeg' &&
      last.toLowerCase() !== 'jpg' &&
      last.toLowerCase() !== 'png' &&
      last.toLowerCase() !== 'PNG' &&
      last.toLowerCase() !== 'gif'
      //End
    ) {
      return showNotification.warning(
        `${entitiesLabels.WARNING}`,
        'This format cannot be accepted'
      );
    }
    if (
      this.state.attachment.type === 'Files' &&
      //RITM1019407
      last.toLowerCase() !== 'doc' &&
      last.toLowerCase() !== 'docx' &&
      last.toLowerCase() !== 'xls' &&
      last.toLowerCase() !== 'xlsx' &&
      last.toLowerCase() !== 'ppt' &&
      last.toLowerCase() !== 'pptx' &&
      last.toLowerCase() !== 'zip' &&
      last.toLowerCase() !== 'txt' &&
      last.toLowerCase() !== 'pdf'
      //End
    ) {
      return showNotification.warning(
        `${entitiesLabels.WARNING}`,
        'This format cannot be accepted'
      );
    }
    if (
      this.props.flagNotificationTab === true &&
      this.state.attachment.type === 'Pictures' &&
      size >= 3145728
    ) {
      return showNotification.warning(`${entitiesLabels.WARNING}`, 'Image size too large');
    } else {
      const attachment = { ...this.state.attachment };

      attachment.id = uuid();
      attachment.fileIdentifier = fileIdentifier.blobName;
      attachment.name = fileName;
      attachment.contentType = fileType;
      attachment.size = size;
      // attachment.filePath = file.localPath;

      this.toggleModal(false);
      this.setState({
        attachment: this.clearAttachment(),
      });
      return this.props.addNewAttachment(attachment);
    }
  };

  remove = (id) => {
    this.props.removeAttachment(id);
  };

  calculateImageAttachmentSize = () => {
    return this.props.attachments?.filter(a => a.attachment.contentType.includes('image') && a.attachment.size).reduce((prev, cur) => prev = prev + Number(cur.attachment.size) , 0 )
  };

  render() {
    const validations = {
      type: this.validator.message('type', this.state.attachment.type, 'required'),
      file: this.validator.message('type', this.state.attachment.id, 'required'),
    };
    const rows = this.props.attachments || [];

    const modalHeader = {
      title: 'Add new',
      iconDescription: 'Close',
      buttonOnClick: () => this.toggleModal(false),
    };

    return (
      <>
        <div className="bx--row">
          <div className="bx--col-lg-12">
            <TableToolbar>
              <h3 className="title--medium max-width" />
              {!this.props.isDisabled && (
                <Button
                  onClick={() => {
                    this.addAttachment();
                  }}
                  renderIcon={Add16}
                >
                  Add new
                </Button>
              )}
            </TableToolbar>
            <TableContainer className="bx--grid--full-width">
              <Table>
                <TableHead className="colorgray">
                  <TableRow>
                    <TableHeader>Name</TableHeader>
                    <TableHeader>Type</TableHeader>
                    <TableHeader>Size</TableHeader>
                    <TableHeader className="align-center">Actions</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows == null || rows.length === 0 ? (
                    <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                  ) : (
                    rows.map((item, index) => (
                      <TableRow key={`row_${item.id}`}>
                        <TableCell key={`cell_1_${item.id}`}>{item.attachment.name}</TableCell>
                        <TableCell key={`cell_2_${item.id}`}>{item.attachment.type}</TableCell>
                        <TableCell key={`cell_3_${item.id}`}>{`${(Number(item.attachment.size)/(1024*1024)).toFixed(2)} MB`}</TableCell>
                        <TableCell key={`action-${item.id}`} className="tableActions align-center">
                          <div>
                            <Online>
                              <FileDownLoadButton
                                onError={(error) => {
                                  showNotification.error(
                                    `${entitiesLabels.ERROR}`,
                                    getError(
                                      error,
                                      entitiesLabels.INCIDENT_NOTIFICATION,
                                      apioperation.DOWNLOAD
                                    )
                                  );
                                }}
                                size="small"
                                renderIcon={Download16}
                                iconDescription="Download"
                                kind="ghost"
                                apiUrl={`/incident/${this.state.idIncident}/attachment/${item.attachment.fileIdentifier}`}
                                fileName={item.attachment.name}
                                onDownLoadStart={() => {}}
                                onDownLoadEnd={() => {}}
                              />
                              {!this.props.isDisabled && (
                                <Button
                                  onClick={() => this.remove(item.id)}
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                />
                              )}
                            </Online>
                            <Offline>
                              <FileDownLoadButton
                                disabled={true}
                                onError={(error) => {
                                  showNotification.error(
                                    `${entitiesLabels.ERROR}`,
                                    getError(
                                      error,
                                      entitiesLabels.INCIDENT_NOTIFICATION,
                                      apioperation.DOWNLOAD
                                    )
                                  );
                                }}
                                size="small"
                                renderIcon={Download16}
                                iconDescription="Download"
                                kind="ghost"
                                apiUrl={`/incident/${this.state.idIncident}/attachment/${item.attachment.fileIdentifier}`}
                                fileName={item.attachment.name}
                                onDownLoadStart={() => {}}
                                onDownLoadEnd={() => {}}
                              />
                              {!this.props.isDisabled && (
                                <Button
                                  onClick={() => this.remove(item.id)}
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                  disabled={true}
                                />
                              )}
                            </Offline>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <ComposedModal
          className="light-modal"
          open={this.state.isOpenModal}
          danger="false"
          onClose={() => this.toggleModal(false)}
        >
          <ModalHeader className="margin-modal" {...modalHeader}>
            <p>Attachment</p>
          </ModalHeader>
          <ModalBody className="margin-modal">
            {this.state.isOpenModal ? (
              <div className="bx--grid--full-width">
                <div className="bx--row">
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <FormGroup legendText="Attachment Type">
                      <ComboBox
                        id="type"
                        placeholder="Select"
                        name="type"
                        alt="attachment"
                        onChange={this.updateState}
                        itemToString={(item) => item || ''}
                        items={this.state.attachmentTypes}
                        invalid={validations.type != null}
                      />
                      {validations.type}
                    </FormGroup>
                  </div>
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <FormGroup legendText="Choose file">
                      {this.state.attachment.type && (
                        <FileUpload
                          disabled={!this.state.attachment.type}
                          Container="saipem"
                          StoragePath="incident"
                          onUpload={this.onUpload}
                          accept={
                            this.state.attachment.type.includes('Pictures')
                              ? ['.jpeg', '.jpg', '.png', '.gif']
                              : this.props.flagNotificationTab
                              ? ['.doc', '.docx', '.xls', '.xlsx', '.pdf', '.ppt', '.zip']
                              : null
                          }
                          acceptDescription={
                            this.state.attachment.type.includes('Pictures')
                              ? 'jpeg, jpg, png and gif files accepted.'
                              : this.props.flagNotificationTab
                              ? 'only PowerPoint, Pdf, Word, Excel, txt, zip files at 8mb or less'
                              : null
                          }
                          sumImageAttachmentSize = {this.calculateImageAttachmentSize()}
                        />
                      )}
                      {validations.file}
                    </FormGroup>
                  </div>
                </div>
              </div>
            ) : null}
          </ModalBody>
          {/* <ModalFooter >
                    <Button kind="secondary" onClick={() => this.toggleModal(false)}>Cancel</Button>
                    <Button kind='primary' onClick={() => this.save()}>Save</Button>
                </ModalFooter> */}
        </ComposedModal>
      </>
    );
  }
}
